import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Layout } from 'antd'
import { User, HeaderProps } from './header'
import styles from './header.module.less'
import extraStyles from './sanw-header.module.less'

const Logo = () => {
  return (
    <div className={extraStyles.logoBox}>
      <img
        src="//pic2.58cdn.com.cn/nowater/fangfe/n_v221ba75d013e046a3b7193b20626bf95b.png"
        alt=""
        className={extraStyles.logo}
      />
    </div>
  )
}

const SanwHeader = (props: PropsWithChildren<HeaderProps>) => {
  const headerClass = classNames(styles.header, extraStyles.header)
  return (
    <div className={props.className}>
      <div className={styles.container}>
        <div className={styles.ribbon} />
        <Layout.Header className={headerClass}>
          <div className={styles.inner}>
            <Logo />
            <User revertColor={true} useOnlyNewLayout={props.useOnlyNewLayout}/>
          </div>
        </Layout.Header>
      </div>
    </div>
  )
}

export { SanwHeader }
